import { ReactNode, useState } from 'react'

import { Disclosure, DisclosurePanel } from '@headlessui/react'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { DefinitionMarkdownSubNav } from './DefinitionMarkdownSubNav'
import { calculateNestedMargin } from '~/portal/components/ConsumerSideNavigation/helpers'
import { SideNavItem } from '~/portal/components/ConsumerSideNavigation/SideNavItem'
import { ApiTocItem, DefinitionMarkdownComponent } from '~/portal/types/content'

export const DefinitionMarkdownNavItem = ({
  item,
  components,
  icon,
  isActive,
  level,
  openIds,
  onClick,
  isMobile,
  flat,
  apiTitle,
}: {
  item: ApiTocItem,
  components?: DefinitionMarkdownComponent[],
  icon: ReactNode,
  isActive: boolean,
  level: number,
  openIds: string[],
  onClick?: (e: any) => void,
  isMobile?: boolean,
  flat?: boolean,
  apiTitle?: string,
}) => {
  const { t } = useTranslation()
  const location = useLocation()

  const [selectedComponentItem, setSelectedComponentItem] = useState<string | null>(null)

  const hasComponents = Boolean(components && components.length > 0)

  const subNavContent = (
    <div className={clsx('sp-sidenav-api-subnav', isActive ? 'bg-(--sp-sidenav-item-active-bg,var(--sp-color-surface-raised)) rounded-b' : 'bg-(--sp-sidenav-item-bg,var(--sp-color-surface))')}>

      {hasComponents ? components!.map(component => (
        <DefinitionMarkdownSubNav
          key={component.title}
          component={component.title}
          componentItems={component.items}
          active={isActive}
          parentPath={`${item.path}${location.search}`}
          level={level}
          selectedComponentItem={selectedComponentItem}
          setSelectedComponentItem={setSelectedComponentItem}
          onClick={onClick}
        />
      )) : null}
      <div className="separator h-1.5" />
    </div>
  )

  if (flat) {
    return (
      <>
        <SideNavItem
          path={`${item.path}#top`}
          title={apiTitle ?? ''}
          icon={icon}
          isActive={isActive}
          isExpandable={false}
          level={level}
          isApi={true}
          selectedItem={selectedComponentItem}
          setSelectedItem={setSelectedComponentItem}
          onClick={onClick}
          isMobile={isMobile}
          useMarkdocRenderer={true}
        />
        {subNavContent}
      </>
    )
  }

  return (
    <Disclosure aria-label={t('consumer.sideNavigation.apiNavItem.ariaLabel')} as="div" defaultOpen={openIds.includes(item.tableOfContentsId ?? '')} key={`${item.path ?? ''}-${openIds.join('-')}`}>
      {({ open }) => (
        <>
          <SideNavItem
            path={`${item.path}${location.search}#top`}
            title={item.title}
            icon={icon}
            isActive={isActive}
            isExpandable={hasComponents}
            level={level}
            open={open}
            isApi={true}
            selectedItem={selectedComponentItem}
            setSelectedItem={setSelectedComponentItem}
            onClick={onClick}
            isMobile={isMobile}
            useMarkdocRenderer={true}
          />
          <DisclosurePanel style={{ paddingLeft: calculateNestedMargin(level, isMobile) }} className={clsx(level > 0 && 'pr-3')}>
            {subNavContent}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  )
}
